const PURCHASE_STATUSES = {
    SUCCESS: 0,
    ERROR: 1,
    CANCELLED: 2,
};

export { PURCHASE_STATUSES };
//# sourceMappingURL=purchaseStatuses.js.map
